import React from "react";
import TabletLayout from "../../Shared/TabletLayout";
import TabletNotice from "../../Shared/TabletNotice";
import OriginalComponentImpl from "../../../Components/Main/HomePage/Authentication/SummaryPopup";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const SummaryPopupTablet: React.FC<Props> = (props) => {
  return (
    <TabletLayout title="SummaryPopup">
      <TabletNotice page="SummaryPopup" />
      <OriginalComponent {...props} />
    </TabletLayout>
  );
};

export default SummaryPopupTablet;